import { gql } from "@apollo/client";

export default gql`
  fragment CommentFieldsLegacy on Comment {
    _id
    body
    author {
      ... on GovernmentUser {
        _id
        slug
        firstName
        fullName
        jobTitle
        title
        avatar
        isInnovator
      }
      ... on VendorUser {
        _id
        slug
        firstName
        title
        fullName
        jobTitle
        avatar
      }
      ... on PendingUser {
        _id
        slug
        firstName
        fullName
        jobTitle
        avatar
      }
    }
    createdAt
    lastUpdatedAt
    viewerDidUpvote
    upvotesCount
    isReply
    replies {
      _id
      body
      author {
        ... on GovernmentUser {
          _id
          slug
          firstName
          fullName
          title
          jobTitle
          avatar
          isInnovator
        }
        ... on VendorUser {
          _id
          slug
          firstName
          fullName
          title
          jobTitle
          avatar
        }
        ... on PendingUser {
          _id
          slug
          firstName
          fullName
          jobTitle
          avatar
        }
      }
      createdAt
      lastUpdatedAt
      viewerDidUpvote
      upvotesCount
      isReply
    }
  }
`;
